import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Item } from '../Item'
import { connect } from 'react-redux'
import { getCurrentAd } from '../../../selectors'
import { groups } from 'SRC/modules/ads/equipment/data/groups'

export const ListMobile = ({ad: {equipment}}) => {
  const { t } = useTranslation('common')

  const equipmentSorted = equipment.sort((a, b) => {
    if (a.weight !== b.weight) {
      return a.weight - b.weight
    } else {
      return a.title.localeCompare(b.title)
    }
  })
  const equipmentByGroups = []
  for (let key in groups) {
    if (groups.hasOwnProperty(key)) {
      const group = {...groups[key]}
      group.items = equipmentSorted.filter(item => item.grupa === group.code).map(item => ({
        id: item.id,
        feature: item.title,
        hint: item.hint
      }))
      equipmentByGroups.push(group)
    }
  }
  return equipmentByGroups.map(({id, title, items}) => {
    if (!items.length) {
      return null
    }

    const itemsByColumn = items

    return (
      <div className='oglasi-dodatna-oprema' key={id}>
        <div className='oglasi-info-heading'>
          <p>{t(title)}</p>
        </div>
        <div className='oglasi-dodatne-oprema-content'>
          <ul>{itemsByColumn.map(item => <Item {...item} key={item.id} />)}</ul>
        </div>
      </div>
    )
  })
}

const mapStateToProps = state => ({
  ad: getCurrentAd(state)
})

ListMobile.propTypes = {
  ad: PropTypes.shape({
    equipment: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      grupa: PropTypes.string.isRequired,
      hint: PropTypes.string,
      title: PropTypes.string.isRequired
    }))
  })
}

ListMobile.defaultProps = {
  items: []
}

ListMobile.displayName = 'EquipmentMobile'

export default connect(mapStateToProps)(ListMobile)
